import React from 'react';
import { Button } from 'react-bootstrap';
import './CancelButton.css';

const CancelButton = ({
  children,
  onClick,
  disabled = false,
  variant = 'light',
  size = '',
  className = '',
  // Dynamic styling props with defaults
  mobileWidth = null,
  width = 'fit-content',
  height = 'auto',
  padding = '0.6rem 1.2rem',
  margin = '0',
  fontSize = '14px',
  fontWeight = '600',
  borderRadius = 'var(--radius-sm)',
  backgroundColor = 'transparent',
  borderColor = '#d1d5db',
  color = '#374151',
  hoverBackgroundColor = '#f9fafb',
  hoverBorderColor = '#9ca3af',
  hoverColor = '#374151',
  boxShadow = 'none',
  hoverBoxShadow = 'none',
  transform = 'none',
  hoverTransform = '',
  transition = 'none',
  ...props
}) => {
  const dynamicStyle = {
    width,
    height,
    padding,
    margin,
    fontSize,
    fontWeight,
    borderRadius,
    backgroundColor,
    borderColor,
    color,
    boxShadow,
    transform,
    transition,
    // CSS custom properties for hover states
    '--hover-bg': hoverBackgroundColor,
    '--hover-border': hoverBorderColor,
    '--hover-color': hoverColor,
    '--hover-shadow': hoverBoxShadow,
    '--hover-transform': hoverTransform,
    '--mobile-width': mobileWidth || width,
    ...props.style
  };

  return (
    <Button
      className={`cancel-btn ${className}`.trim()}
      onClick={onClick}
      disabled={disabled}
      variant={variant}
      size={size}
      style={dynamicStyle}
      {...(({ style, ...rest }) => rest)(props)}
    >
      {children}
    </Button>
  );
};

export default CancelButton;